import './color.css';
import './root.css';
export var theme = {
    color: 'yandex-default',
    root: 'default',
};
